import React from "react";
import "./AboutUj.css";


export default function AboutUs() {
 
  return (
    <>
      <div className="aboutus">
        <h1>Our Histroy</h1>
        <p>
        n my wanderlust-filled journey, I hope to inspire you to venture beyond your comfort zone, to embrace the unknown, and to celebrate the diversity that enriches our world. So pack your virtual bags and join me as we explore cultures, capture breathtaking sights, and uncover the stories that make each destination truly unique.
        </p>
        <h1>Our Mission</h1>
        <p>
         Our mission is touch to hoeizen where our capability ,ay suxxessfully meet wuth the requirement of our clints, that too with ultimate transparency and coss-effectiveness.
        </p>
        <h1>Our Vision</h1>
        <p>
          To saw the seeds of par-excellence services with customer centric approch and reap the trust of worldwide clients.
        </p>
        
      
       
      
      </div>
    </>
  );
}
